import { CoursePhoto } from '../../../../shared/framework/images/models/CoursePhoto';
import { Observable } from 'rxjs';
import { LearningPathStudentActivityAttachment } from './LearningPathStudentActivityAttachment';
import { LearningPathStudentActivityElearning } from './LearningPathStudentActivityElearning';
import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';
import { LearningPathStudentActivityCourse } from './LearningPathStudentActivityCourse';
import { UserLevel, UserLevelEnum } from 'src/app/auth/models/UserData';
import { EmployeeStatus } from 'src/app/shared/personnel-files/enums/EmployeeStatus';
import { ConversationPrivateParticipant } from 'src/app/modules/conversations/models/ConversationPrivateParticipant';

export enum LearningPathManagerView {
  Employees,
  Enroll,
  Info,
}

export enum LearningPathActivityType {
  Training = 1,
  Library = 2,
  KnowledgeTest = 3,
  Elearning = 5,
}

export class Learnpath {
  learningPathId: number;
  name: string;
  code: string;
  active: boolean;
  coursePhotoId: number;
  coursePhoto: CoursePhoto;
  details: string;
  registerByEmp;
  registerByEmpDays: number;
  registerByMgr: boolean;
  registerByMgrDays: number;
  showHomePageEmp: boolean;
  activitiesFixedOrder: boolean;
  availableDays: number;
  reminderDays: number;
  studentCount?: number;
  attentionYears?: number;
}

export class LearningPathOverview {
  learningPathId: number;
  coursePhotoId: number;
  coursePhoto: CoursePhoto;
  name: string;
  active: boolean;
  activitiesFixedOrder: boolean;
  activityCount: number;
  studentCount: number;
  details: string;
  notCompletedStudentCount: number;
  actionsRequired?: number;
  availableDays: number;
  nearDeadline: number;
}

export class ActivityLabel {
  learningPathActivitylabelId?: number;
  learningPathActivityId?: number;
  languageId: number;
  labelName: string;
  labelDescription: string;
}

export class LearnpathActivity {
  learningPathActivityId: number;
  learningPathId: number;
  name: string;
  coursePhotoId: number;
  coursePhoto: CoursePhoto;
  active: boolean;
  activityTypeId: number;
  activityContentId: number;
  activityContentLabel: string;
  isTest: boolean;
  testMinimumPercentage: number;
  description: string;
  mandatory: boolean;
  whoCreated: string;
  updatedDate: string;
  order: number;
  attentionYears: number;
  activityLabels?: ActivityLabel[];

  typeName?: string;
}

export class ActivityFiles {
  fileId: number;
  fileName: string;
  fileSize: number;
  fileLink: string;
  contentType: string;
  hash: string;
  updatedDate: string;
}
export class LearnpathActivityType {
  activityTypeId: number;
  label: string;
  code: string;
  Order: number;
  languageId: number;
  showTestOption: boolean;
}
export class ActivityContent {
  contentId: number;
  name: string;
  extra: string;
  language?: string;
  isActive?: boolean;
}

export class Student {
  studentId: number;
  firstName: string;
  lastName: string;
  status: EmployeeStatus;
  dateFormat: string;
  languageId: number;
  level: UserLevelEnum;
  jobClass: number;
  manager: string;
  managerId: number;

  functionId?: number;
  function: string;
  departmentId?: number;
  department: string;
  companyId?: number;
  company: string;
  birthday: Date;

  hasPhoto: boolean;

  pictureError?: boolean;
  selected?: boolean;
  name?: string;
  hasOngoingConversationOfNewTemplate?: boolean;
  conversationPrivateParticipants?: ConversationPrivateParticipant[];
  conversationPrivateParticipantsCheckall?: boolean;
}

export class StudentForGroup {
  studentId: number;
  firstName: string;
  lastName: string;

  functionId?: number;
  function: string;
  departmentId?: number;
  department: string;
  companyId?: number;
  company: string;

  name?: string;
  selected?: boolean;
}

export class LearningPathStudentGeneral {
  learningPathStudentId: number;
  studentId: number;
  learningPathId: number;
  firstName: string;
  lastName: string;
  learningPathStudentStatus: number;
  inviteDate: Date;
  finishedDate: Date;
  daysSindsInvite: number;
  deadline?: Date;
  deadlineClose: boolean;
  collapsed?: boolean;
  hasPhoto: boolean;
}

export class LearningPathStudentActivityStatus {
  learningPathStudentActivityStatusId: number;
  languageId: number;
  label: string;
}
export class StudentActivityWithHelpers {
  activities: LearningPathStudentActivityGeneral[];
  learnPath: LearningPathStudent;
  activityStatusList: LearningPathStudentActivityStatus[];
}
export class LearningPathActivityGeneral {
  activityId: number;
  learningPathId: number;
  name: string;
  description: string;
  coursePhotoId: number;
  coursePhoto: CoursePhoto;
  order: string;
  activityContentId: number;
  activityContentLabel: number;
}

export class LearningPathStudentActivityGeneral {
  id?: number;
  name: string;
  coursePhotoId: number;
  coursePhoto: CoursePhoto;
  description: string;
  order: number;
  studentActivityId: number;
  activityId: number;
  learningPathStudentId: number;
  studentId: number;

  /** 1: Not started, 2: Started, 3: Finished */
  activityStatusId: number;
  activityStatusLabel: string;
  activityContentId: number;
  activityContentLabel: string;
  activityContentExtra: string;
  activityTypeId: number;
  startDate: Date;
  finishedDate: Date;
  studentComment: string;
  managerComment: string;
  canStart: boolean;
  isTest: boolean;
  testMinimumPercentage: number;
  score?: number;
  file$: Observable<LearningPathStudentActivityAttachment>;
  elearning?: LearningPathStudentActivityElearning;
  course?: LearningPathStudentActivityCourse;
  mandatory: boolean;

  attachments: any[];
  isNotStarted: boolean;
  isFinished: boolean;

  activityTypeLabel?: string;
}

export class LearningPathStudentSubscription {
  learningPathId: number;
  createStudent: boolean;
  learningPathStudentId?: number;
  studentId?: number;
}

export class LearningPathStudentDashboard {
  unsubscribed: Array<Student>;
  invited: Array<LearningPathStudentGeneral>;
  subscribed: Array<LearningPathStudentGeneral>;
}

export class LearningPathStudentOverview {
  learningPath: LearningPathOverview;
  activities: Array<LearningPathActivityGeneral>;
  students: Array<LearningPathStudentGeneral>;
  studentActivities: Array<LearningPathStudentActivityGeneral>;
}

export class LearningPathStudentDetail {
  learningPath: LearningPathOverview;
  student: LearningPathStudentGeneral;
  studentActivities: Array<LearningPathStudentActivityGeneral>;
}
export class LearningPathStudent {
  name: string;
  learningPathStudentId: number;
  learningPathId: number;
  studentId: number;
  learningPathStudentStatus: number;
  studentComment: string;
  managerComment: string;
  autoInvite: boolean;
  whoKind: number;
  whoId: number;
  inviteDate: Date;
  finishDate: Date;
  activitiesFixedOrder: boolean;
  activities: any[];
  daysSindsInvite: number;
  deadline?: Date;
  coursePhotoId?: number;
  details: string;
  coursePhoto: IDataUrlParam;

  deadlineClose?: boolean;
  acceptDate?: Date;
}

export class LearningPathStudentList {
  name: string;
  inviteDate: Date;
  finishDate: Date;
  acceptDate: Date;
  activities: LearningPathStudentActivityList[];
  learningPathStudentId: number;
  learningPathId: number;
  studentId: number;
  learningPathStudentStatus: number;
  learningPathStudentStatusName: string;
}
export class LearningPathStudentActivityList {
  id: number;
  name: string;
  isFinished: boolean;
}

export class LearningPathActivityStudentDetailed {
  learningPathStudentId: number;
  studentActivityId: number;
  activityStatusId: number;
  studentId: number;
  inviteDate?: Date;
  activityTypeId?: number;
  mandatory?: boolean;
  startDate?: Date;
  finishedDate?: Date;
  attemptCount?: number;
  checkDate: Date;
  isTest?: boolean;
  score?: number;
  firstName: string;
  lastName: string;
  hasPhoto?: boolean;
  daysAgo?: number;
  studentComment: string;
  managerComment: string;
  editMode: boolean;

  order?: number;
  name?: string;

  attachments: any[];


  // only for admin edit
  newActivityStatusId?: number;
  newManagerComment?: string;
}

export class LearnpathActivityDetailed {
  activityId: number;
  learningPathId: number;
  name: string;
  description: string;
  coursePhotoId: number;
  order: number;
  activityTypeId: number;
  activityContentId: number;
  activityContentLabel: string;
  mandatory: boolean;
  isTest: boolean;
  whoKind: number;
  whoId: number;
  createDate: Date;
  attentionYears?: number;
  canDeleteLearningPathActivityId: boolean;

  // extra
  coursePhoto?: CoursePhoto;
  active: boolean;
  testMinimumPercentage?: number;
  whoCreated?: string;
  updatedDate?: string;
  activityLabels?: ActivityLabel[];

  learningPathStudentActivities: LearningPathActivityStudentDetailed[];
}
